export const CLIENT_SIGNUP_WORKFLOW_CANCELED_EVENT = 'signupworkflow:canceled';
